import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'sl11',
  templateUrl: './sl11.component.html',
  styleUrls: ['./sl11.component.scss']
})
export class SL11Component {
  protected company: string = environment.company;

  @Input() package: any;
  @Output() link = new EventEmitter<string>();

  emitLink(link: string): void {
    this.link.emit(link);
  }
}
